export var TeamMemberBrand;
(function (TeamMemberBrand) {
    TeamMemberBrand["aussie"] = "AUSSIE";
    TeamMemberBrand["domain"] = "DOMAIN";
    TeamMemberBrand["lendi"] = "LENDI";
})(TeamMemberBrand || (TeamMemberBrand = {}));
export var TeamMemberProfile;
(function (TeamMemberProfile) {
    TeamMemberProfile["associate"] = "Associate";
    TeamMemberProfile["broker"] = "Broker";
    TeamMemberProfile["brokerManager"] = "Broker Manager";
    TeamMemberProfile["customerSolutions"] = "Customer Solutions";
    TeamMemberProfile["offboardedUser"] = "Offboarded User";
    TeamMemberProfile["partnerBroker"] = "Partner Broker";
    TeamMemberProfile["relationshipManager"] = "Relationship Manager";
    TeamMemberProfile["seniorRelationshipManager"] = "Senior Relationship Manager";
})(TeamMemberProfile || (TeamMemberProfile = {}));
export var TeamMemberUserRole;
(function (TeamMemberUserRole) {
    TeamMemberUserRole["aussieExecutive"] = "AUSSIE_EXECUTIVE";
    TeamMemberUserRole["aussieAssociateManager"] = "AUSSIE_ASSOCIATE_MANAGER";
    TeamMemberUserRole["aussieAssociate"] = "AUSSIE_ASSOCIATE";
    TeamMemberUserRole["brokerLifecycle"] = "BROKER_LIFECYCLE";
    TeamMemberUserRole["clientSolutions"] = "CLIENT_SOLUTIONS";
    TeamMemberUserRole["clientSolutionsAssessmentAssociate"] = "CLIENT_SOLUTIONS_ASSESSMENT_ASSOCIATE";
    TeamMemberUserRole["clientSolutionsAssessmentExpert"] = "CLIENT_SOLUTIONS_ASSESSMENT_EXPERT";
    TeamMemberUserRole["clientSolutionsManager"] = "CLIENT_SOLUTIONS_MANAGER";
    TeamMemberUserRole["clientSolutionsSettlementAssociate"] = "CLIENT_SOLUTIONS_SETTLEMENT_ASSOCIATE";
    TeamMemberUserRole["clientSolutionsSettlementExpert"] = "CLIENT_SOLUTIONS_SETTLEMENT_EXPERT";
    TeamMemberUserRole["clientSolutionsSpecialist"] = "CLIENT_SOLUTIONS_SPECIALIST";
    TeamMemberUserRole["domainAssociate"] = "DOMAIN_ASSOCIATE";
    TeamMemberUserRole["domainAssociateManager"] = "DOMAIN_ASSOCIATE_MANAGER";
    TeamMemberUserRole["domainBrokerLiaison"] = "DOMAIN_BROKER_LIAISON";
    TeamMemberUserRole["domainBrokerManager"] = "DOMAIN_BROKER_MANAGER";
    TeamMemberUserRole["domainExecutive"] = "DOMAIN_EXECUTIVE";
    TeamMemberUserRole["domainHomeLoanSpecialist"] = "DOMAIN_HOME_LOAN_SPECIALIST";
    TeamMemberUserRole["domainSalesExecutive"] = "DOMAIN_SALES_EXECUTIVE";
    TeamMemberUserRole["fieldAssistant"] = "FIELD_ASSISTANT";
    TeamMemberUserRole["franchiseeBroker"] = "FRANCHISEE_BROKER";
    TeamMemberUserRole["franchiseeNonBroker"] = "FRANCHISEE_NON_BROKER";
    TeamMemberUserRole["graduateManager"] = "GRADUATE_MANAGER";
    TeamMemberUserRole["lendiAssociate"] = "LENDI_ASSOCIATE";
    TeamMemberUserRole["lendiAssociateManager"] = "LENDI_ASSOCIATE_MANAGER";
    TeamMemberUserRole["lendiBrokerAdmin"] = "LENDI_BROKER_ADMIN";
    TeamMemberUserRole["lendiBrokerLiaison"] = "LENDI_BROKER_LIAISON";
    TeamMemberUserRole["lendiBrokerManager"] = "LENDI_BROKER_MANAGER";
    TeamMemberUserRole["lendiExecutive"] = "LENDI_EXECUTIVE";
    TeamMemberUserRole["lendiGroupExecutive"] = "LENDI_GROUP_EXECUTIVE";
    TeamMemberUserRole["lendiHomeLoanConsultant"] = "LENDI_HOME_LOAN_CONSULTANT";
    TeamMemberUserRole["lendiHomeLoanSpecialist"] = "LENDI_HOME_LOAN_SPECIALIST";
    TeamMemberUserRole["lendiSalesExecutive"] = "LENDI_SALES_EXECUTIVE";
    TeamMemberUserRole["lendiSameLenderRefinance"] = "LENDI_SAME_LENDER_REFINANCE";
    TeamMemberUserRole["mobileRegionHead"] = "MOBILE_REGION_HEAD";
    TeamMemberUserRole["mobileRegionManager"] = "MOBILE_REGION_MANAGER";
    TeamMemberUserRole["mobileBroker"] = "MOBILE_BROKER";
    TeamMemberUserRole["seniorRelationshipManager"] = "SENIOR_RELATIONSHIP_MANAGER";
    TeamMemberUserRole["offboardedTeamMember"] = "OFFBOARDED_TEAM_MEMBER";
    TeamMemberUserRole["relationshipManager"] = "RELATIONSHIP_MANAGER";
    TeamMemberUserRole["retailStateHead"] = "RETAIL_STATE_HEAD";
    TeamMemberUserRole["retailManager"] = "RETAIL_MANAGER";
    TeamMemberUserRole["retailBroker"] = "RETAIL_BROKER";
    TeamMemberUserRole["storeAdmin"] = "STORE_ADMIN";
    TeamMemberUserRole["trainer"] = "TRAINER";
})(TeamMemberUserRole || (TeamMemberUserRole = {}));
export var TeamMemberSalutation;
(function (TeamMemberSalutation) {
    TeamMemberSalutation["mr"] = "Mr.";
    TeamMemberSalutation["ms"] = "Ms.";
    TeamMemberSalutation["mrs"] = "Mrs.";
    TeamMemberSalutation["dr"] = "Dr.";
    TeamMemberSalutation["prof"] = "Prof.";
})(TeamMemberSalutation || (TeamMemberSalutation = {}));
export var TeamMemberRestrictionStatus;
(function (TeamMemberRestrictionStatus) {
    TeamMemberRestrictionStatus["restricted"] = "RESTRICTED";
    TeamMemberRestrictionStatus["unrestricted"] = "UNRESTRICTED";
})(TeamMemberRestrictionStatus || (TeamMemberRestrictionStatus = {}));
export var TeamMemberBrokerStatus;
(function (TeamMemberBrokerStatus) {
    TeamMemberBrokerStatus["competent"] = "Competent";
    TeamMemberBrokerStatus["compliance"] = "Compliance";
    TeamMemberBrokerStatus["graduate"] = "Graduate";
    TeamMemberBrokerStatus["pip"] = "PIP";
    TeamMemberBrokerStatus["offBoarded"] = "Off Boarded";
    TeamMemberBrokerStatus["roleChange"] = "Role Change";
    TeamMemberBrokerStatus["active"] = "Active";
    TeamMemberBrokerStatus["suspended"] = "Suspended";
})(TeamMemberBrokerStatus || (TeamMemberBrokerStatus = {}));
export var TeamMemberTimeZone;
(function (TeamMemberTimeZone) {
    TeamMemberTimeZone["adelaide"] = "Australia/Adelaide";
    TeamMemberTimeZone["brisbane"] = "Australia/Brisbane";
    TeamMemberTimeZone["brokenHill"] = "Australia/Broken_Hill";
    TeamMemberTimeZone["currie"] = "Australia/Currie";
    TeamMemberTimeZone["darwin"] = "Australia/Darwin";
    TeamMemberTimeZone["eucla"] = "Australia/Eucla";
    TeamMemberTimeZone["hobart"] = "Australia/Hobart";
    TeamMemberTimeZone["lindeman"] = "Australia/Lindeman";
    TeamMemberTimeZone["lordHowe"] = "Australia/Lord_Howe";
    TeamMemberTimeZone["melbourne"] = "Australia/Melbourne";
    TeamMemberTimeZone["perth"] = "Australia/Perth";
    TeamMemberTimeZone["sydney"] = "Australia/Sydney";
})(TeamMemberTimeZone || (TeamMemberTimeZone = {}));
export var TeamMemberCommissionStatus;
(function (TeamMemberCommissionStatus) {
    TeamMemberCommissionStatus["active"] = "Active";
    TeamMemberCommissionStatus["inactive"] = "Inactive";
    TeamMemberCommissionStatus["suspended"] = "Suspended";
})(TeamMemberCommissionStatus || (TeamMemberCommissionStatus = {}));
//# sourceMappingURL=TeamMember.js.map